/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { AuthService, Logger, LogService, UserData } from '@epg/angular-base-lib';
import { firstValueFrom, Observable, ReplaySubject } from 'rxjs';
import { SearchModel } from 'src/models/search.model';
import { ApiService } from './api.service';
import { TenantService } from '@epg/ng-components';
import { TenantDto } from '@epg/tenant-manager-client';
import { Injectable } from '@angular/core';

export const ACTIVE_TENANT_VARIABLE = 'activeTenant';

@Injectable({
  providedIn: 'root'
})
export class TenantMappingService extends TenantService {
  private log: Logger;

  constructor(
    private apiService: ApiService,
    private logService: LogService,
    private authService: AuthService,
  ) {
    super();
    this.log = this.logService.getLogger(this);
  }
  applicationName = 'oneapp';
  activeTenantChanged: ReplaySubject<TenantDto | null> = new ReplaySubject<TenantDto | null>(1);

  private _activeTenant!: TenantDto | null;

  get activeTenant(): TenantDto | null {
    return this._activeTenant;
  }

  setActiveTenant(tenant: TenantDto | null): void {
    this._activeTenant = tenant;
    this.activeTenantChanged.next(this._activeTenant);
  }

  get activeTenant$(): Observable<TenantDto | null> {
    return this.activeTenantChanged.asObservable();
  }

  getActiveTenantName(): Promise<string | undefined> {
    return new Promise(async (resolve) => {
      const currentUser: UserData = await this.authService.getUserInfo();
      if (currentUser) {
        const tenantFromSessionStorage = this.getActiveTenantFromSessionStorage();
        if (tenantFromSessionStorage) {
          resolve(tenantFromSessionStorage);
        } else {
          const $employee = this.apiService.search(
            'search/employee',
            this.getSearchModel(currentUser.email)
          );
          await firstValueFrom($employee).then((response) => {
            let employees = response.body ?? [];
            resolve(employees[0].default_tenant);
          }).catch(() => {
            resolve(undefined);
          });
        }
      }
    });
  }

  getActiveTenantFromSessionStorage(): string | undefined {
    return sessionStorage.getItem(ACTIVE_TENANT_VARIABLE) ?? undefined;
  }

  setActiveTenantToSessionStorage(activeTenant: string): void {
    sessionStorage.setItem(ACTIVE_TENANT_VARIABLE, activeTenant);
  }

  removeActiveTenantFromSessionStorage(): void {
    sessionStorage.removeItem(ACTIVE_TENANT_VARIABLE);
  }

  getSearchModel(username: string): SearchModel {
    return {
      search_criteria: { user_name: username },
      sort: '',
      select: 'default_tenant',
      skip: 0,
      limit: 0
    };
  }
}
